import {useState, useEffect} from 'react'
import Recibo from './recibo.js'

export default function LisCateg (props) {
    const [data, setdata] = useState('')
    const [elegido, setElegido] = useState({id:0})
    const [apellido, setApellido] = useState('')
    const [nombre, setNombre] = useState('')
    const [documento, setDocumento] = useState('')
    const [recibos, setRecibos] = useState([])

    useEffect (() => {
        const d = props.socios.map(a => {
            if ((apellido==='' || a.apellido.toLowerCase().includes(apellido.toLowerCase())) &&
                ((nombre==='' || a.nombre.toLowerCase().includes(nombre.toLowerCase()))) &&
                ((documento==='' || a.documento.toString().includes(documento.toString())))
                )   
            return (
            <div 
                className='grid grid-cols-3 text-sm gap-2 w-full'
                key={a.id}
                onClick={e => setElegido(a)}
            >
                <label classname='flex justify-self-start'>{a.apellido}</label>
                <label classname='flex justify-self-start'>{a.nombre}</label>
                <label classname='flex justify-self-start'>{a.documento}</label>
            </div>
            )   
            else
                return ''
        })
        setdata(d)
    },[props.socios,apellido,nombre,documento])
   
    useEffect(() => {
        if(!elegido.id) {
            setRecibos([])
            return
        }
        fetch (props.back + 'admin/traer_recibos/socioid/' + elegido.id,{
            method: 'GET',
            headers: {
               'Authorization': 'Bearer ' + props.token,
               'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (r => {
            const res = r.map (a => {
                return (
                    <Recibo key={a.id} recibo={a} />
                )
            })
            setRecibos(res) 
        })
    },[elegido, props.back, props.token])

    return (<>
        <div className="px-2 grid grid-cols-2 w-full h-3/4 border-b-2 border-gray-600">
            <div className='flex flex-col w-full py-2 h-full min-h-0'>
                <div className='flex flex-row w-full flex-shrink-0'>
                    <div className="flex flex-row w-1/3 justify-around">
                        Apellidoa
                        <input 
                            type='text'
                            className="outline-0 px-2 w-24"
                            value={apellido}
                            onChange={e => setApellido(e.target.value)}
                        />      
                    </div>
                    <div className='flex flex-row w-1/3 justify-around'>
                        Nombre
                        <input
                            type='text'
                            className="outline-0 px-2 w-24"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />  
                    </div>
                    <div className='flex flex-row w-1/3 justify-around'>
                        Documento
                        <input 
                            type='text'
                            className="outline-0 px-2 w-24"
                            value={documento}
                            onChange={e => setDocumento(e.target.value)}
                        />  
                    </div>
                </div>
                <div className="px-2 mt-3 overflow-y-auto">
                    {data}
                </div>  
            </div>
            <div className='flex flex-col w-full p-2 overflow-y-auto'>
                <div className='flex flex-col items-center font-bold mb-2'>Estado de cuenta de {elegido.apellido} {elegido.nombre}</div>
                {recibos}
            </div>
        </div>
        
        
        
       
        <div>
       </div>
    </>)
}